/**
 * React Query hooks for exchange credential management.
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  listCredentials,
  createCredential,
  deleteCredential,
  testCredential,
} from '../api/client';
import type { CreateCredentialRequest } from '../types';

const CREDENTIALS_KEY = ['credentials'] as const;

export function useCredentials() {
  return useQuery({
    queryKey: CREDENTIALS_KEY,
    queryFn: listCredentials,
  });
}

export function useCreateCredential() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateCredentialRequest) => createCredential(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CREDENTIALS_KEY });
    },
  });
}

export function useDeleteCredential() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteCredential(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CREDENTIALS_KEY });
    },
  });
}

export function useTestCredential() {
  return useMutation({
    mutationFn: (id: string) => testCredential(id),
  });
}
